import type { ILatestUpdatedFiles } from "InterfacesTypes/interfaces";
import { useSelector } from "react-redux";
import { selectRecentlyUpdatedFiles, selectTitleTexts } from "state/selectors/Selectors";
import { CiImageOn } from "react-icons/ci";
import { Link } from "react-router-dom";
import TitleComponent from "components/TitleComponent";
import { TooltipComponent } from "components/toolTipComponent/TooltipComponent";
import { STARTPAGETITLES } from "InterfacesTypes/enums";

const RecentlyUpdatedFiles = () => {
  const files: ILatestUpdatedFiles[] = useSelector(selectRecentlyUpdatedFiles);
  const latestFiveFiles: ILatestUpdatedFiles[] = files.filter(x => x.SiteTitle !== "Internationell Spedition").slice(0, 6); // the first 13  objects are the latest files, they are already sorted in the right order
  const titleTexts = useSelector(selectTitleTexts);
  const recentUpdatedFilesTitle = titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.RECENT_UPDATED_FILES_START_PAGE_TITLE);

  return (
    <>
      {recentUpdatedFilesTitle?.Description ?
        <TooltipComponent
          tooltipClassName="!w-full !max-w-full"
          className="w-full"
          content={recentUpdatedFilesTitle?.Description}
        >
          <div>
            <TitleComponent title={recentUpdatedFilesTitle?.Title ?? "Titel saknas"} />
          </div>
        </TooltipComponent>
        :
        <div>
          <TitleComponent title={recentUpdatedFilesTitle?.Title ?? "Titel saknas"} />
        </div>
      }
      <ul className="!px-3 !mt-6">
        {latestFiveFiles.map((file, i) => (
          <li
            key={i}
            className="hover:scale-105 transition-transform duration-600"
          >
            <a
              href={file.Link}
              className="flex items-start hover:bg-gray-50 !rounded-lg  transition !no-underline w-full"
            >
              <CiImageOn className="!h-[20px] w-[20px] mt-1 mr-4" />
              <div className="w-[60%] ">
                <p className="text-base text-start font-semibold !text-[rgb(44,43,43)] hover:!underline truncate">
                  {file.Title}
                </p>
              </div>
              <div className="w-[5%]"></div>
              <div className="w-[30%] pl-4 truncate text-base">
                {file.SiteTitle}
              </div>
            </a>
          </li>
        ))}
        <li className="flex justify-self-end !mr-4 !mb-2 hover:scale-105 transition-transform duration-600 border-none!">
          <Link className="border-none! hover:bg-transparent! no-underline!" to={"/recentfiles/files"}>Visa fler filer...</Link>
        </li>
      </ul>
    </>
  );
};
export default RecentlyUpdatedFiles;
